import { Card, Table } from "antd";
import { Field, FormikProvider, FormikValues, useFormik } from "formik";
import Input from "../../custom/input/input";
import Button from "../../custom/button/button";
import { useQuery } from "@tanstack/react-query";
import { searchMember } from "../../requests";
import { ColumnsType } from "antd/es/table";
import { useState } from "react";
import { AxiosError } from "axios";

const MemberSearch = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const [hasSearched, setHasSearched] = useState(false);

  const { data, isLoading, isError, error, isFetching, refetch, isRefetching } =
    useQuery({
      queryKey: ["member-search", searchTerm],
      queryFn: () => searchMember(searchTerm),
      enabled: false,
      placeholderData: (prevData) => prevData,
    });

  const formik = useFormik<FormikValues>({
    initialValues: {
      searchStr: "",
    },
    onSubmit: () => {
      refetch();
      setHasSearched(true);
    },
  });

  const columns: ColumnsType<MemberSearchResult> = [
    {
      title: "S/N",
      dataIndex: "Sn",
      key: "Sn",
      render(_d, record, index) {
        return record.Sn || index + 1;
      },
    },
    {
      title: "Membership No",
      dataIndex: "MembershipNo",
      key: "MembershipNo",
    },
    {
      title: "First Name",
      dataIndex: "FirstName",
      key: "FirstName",
    },
    {
      title: "Last Name",
      dataIndex: "LastName",
      key: "LastName",
    },
    {
      title: "Membership Grade",
      dataIndex: "MembershipGrade",
      key: "MembershipGrade",
    },
  ];

  const searchResults = data?.Data as MemberSearchResult[];

  return (
    <div>
      <FormikProvider value={formik}>
        <Card>
          <form onSubmit={formik.handleSubmit}>
            <Field
              name="searchStr"
              as={Input}
              label="Search by member's name, membership number, email or phone number"
              placeholder="Eg. John Smith"
              style={{ maxWidth: "500px" }}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                setSearchTerm(e.target.value);
                formik.setFieldValue("searchStr", e.target.value);
              }}
            />
            <br />
            <Button
              type="submit"
              text="Search"
              isLoading={isLoading || isFetching || isRefetching}
              disabled={isLoading || isFetching || isRefetching}
            />
          </form>
        </Card>
        {hasSearched && (
          <div>
            <br />
            {isError ? (
              <div className="error">{(error as AxiosError)?.message}</div>
            ) : (
              <>
                <h3>Search Results</h3>
                <Table
                  columns={columns}
                  dataSource={searchResults}
                  scroll={{ x: true }}
                  pagination={false}
                  rowKey={(record) => record.MembershipNo}
                  locale={{ emptyText: "No data found" }}
                  rootClassName="table"
                />
              </>
            )}
          </div>
        )}
      </FormikProvider>
    </div>
  );
};

export default MemberSearch;
